/**
 * Handles faq accordions, open close
 * @returns null or creates class
 */
function doFaqAccordion() {
  if (customElements.get("faq-accordion")) return null;

  class FaqAccordion extends HTMLElement {
    constructor() {
      super();
      this.accordionBody = this.querySelector(".faqAccordion-body");
      this.accordionHeader = this.querySelector(".faqAccordion-header");
      this.plus = this.querySelector(".faqAccordion-header .icon-plus");
      this.minus = this.querySelector(".faqAccordion-header .icon-minus");
      if (
        this.accordionBody == null ||
        this.accordionHeader == null ||
        this.plus == null ||
        this.minus == null
      ) {
        console.log("FaqAccordion, one of the constructor variables is null");
        return undefined;
      }
      this.init();
    }

    init() {
      this.accordionHeader.addEventListener("click", () => {
        if (!this.accordionBody.classList.contains("active")) {
          this.toggleAccordion(this.accordionBody, "show");
          return;
        }
        this.toggleAccordion(this.accordionBody, "hide");
      });
    }

    toggleAccordion(element, action = "show") {
      if (action === "show") {
        element.classList.add("active");
        element.style.height = "auto";

        const height = element.clientHeight + "px";
        element.style.height = "0px";

        setTimeout(() => {
          element.style.height = height;
        }, 0);

        this.plus.style.display = "none";
        this.minus.style.display = "block";
        return;
      }

      this.minus.style.display = "none";
      this.plus.style.display = "block";
      element.style.height = "0px";
      element.addEventListener(
        "transitionend",
        () => {
          element.classList.remove("active");
        },
        { once: true }
      );
    }
  }

  customElements.define("faq-accordion", FaqAccordion);
}
doFaqAccordion();
